"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import c from "../components/Icon/SvgIcon.js";
const e = (l) => /* @__PURE__ */ o(
  c,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.555 3.25c-.72 0-1.305.585-1.305 1.305V18.79c0 .72.585 1.305 1.305 1.305h9.891a1.303 1.303 0 0 0 1.293-1.474L15.881 4.386a1.31 1.31 0 0 0-1.294-1.136zm9.891 18.095H6.555A2.56 2.56 0 0 1 4 18.79V4.555A2.56 2.56 0 0 1 6.555 2h8.032c1.279 0 2.367.956 2.534 2.224l1.858 14.235a2.557 2.557 0 0 1-2.533 2.886M14.851 5.313a1 1 0 1 1-1.998.002 1 1 0 0 1 1.998-.002m-2.065 3.379c.79 0 1.584.11 2.283.313l-.477 2.902c-.478-.415-1.11-.768-1.9-.768-1.044 0-2.03.657-2.195 1.486-.167.839.608 1.486 1.654 1.486.803 0 1.495-.273 2.143-.708l-.671 2.852c-.604.212-1.922.303-2.547.303-2.74 0-4.546-1.69-4.111-3.863.443-2.223 3.003-4.003 5.82-4.003",
        clipRule: "evenodd"
      }
    )
  }
), i = t(e);
export {
  i as CostcoPay,
  i as default
};
